import { z } from "zod"

export const setPasswordSchema = z.object({
  email: z.string().email().catch(""),
  token: z.string().min(1).catch(""),
  reason: z
    .union([z.literal("reset"), z.literal("activate")])
    .catch("activate"),
})

export type SetPasswordSearch = z.infer<typeof setPasswordSchema>
